// src/components/parent-dashboard/views/DashboardView.js
import React from "react";
import { AlertCircle, Link as LinkIcon, Mail, PieChart, Search, School, Book, Users, Camera, User } from "lucide-react";
import { getInitials } from "../utils/formatters";
import LinkChildModal from "../modals/LinkChildModal";

/**
 * Main dashboard view component
 * Shows the list of children linked to the parent account
 */
const DashboardView = ({
    children,
    filteredChildren,
    searchQuery,
    setSearchQuery,
    handleChildSelect,
    isLinkModalOpen,
    setIsLinkModalOpen,
    linkEmail,
    setLinkEmail,
    handleLinkChild,
    loading,
    error,
    API_BASE_URL,
    // Parent profile picture props
    parentProfilePicture,
    showParentProfilePictureModal,
    setShowParentProfilePictureModal,
    handleParentProfilePictureUpload,
    uploadingParentPicture,
    getParentInitials
}) => {
    return (
        <div className="min-h-screen bg-[#F7FAFF] font-[poppins]">
            <div className="max-w-7xl mx-auto min-h-screen px-4 sm:px-6 lg:px-8 py-6">
                {/* Header Section with Parent Profile */}
                <div className="pt-8 pb-8 relative overflow-hidden">
                    {/* Parent Profile Picture - Top Right */}
                    {/*<div className="absolute top-4 right-4 z-20">*/}
                    {/*    <button*/}
                    {/*        onClick={() => setShowParentProfilePictureModal(true)}*/}
                    {/*        className="relative group"*/}
                    {/*        title="Update Profile Picture"*/}
                    {/*    >*/}
                    {/*        <div className="w-14 h-14 rounded-full overflow-hidden border-3 border-[#D67C2C] hover:border-[#e06b35] transition-colors shadow-lg">*/}
                    {/*            {parentProfilePicture ? (*/}
                    {/*                <img*/}
                    {/*                    src={parentProfilePicture}*/}
                    {/*                    alt="Your profile"*/}
                    {/*                    className="w-full h-full object-cover"*/}
                    {/*                />*/}
                    {/*            ) : (*/}
                    {/*                <div className="w-full h-full bg-[#FFF8F4] flex items-center justify-center">*/}
                    {/*                    <span className="text-[#D67C2C] font-semibold text-lg">*/}
                    {/*                        {getParentInitials()}*/}
                    {/*                    </span>*/}
                    {/*                </div>*/}
                    {/*            )}*/}
                    {/*        </div>*/}

                    {/*        /!* Hover overlay *!/*/}
                    {/*        <div className="absolute inset-0 rounded-full bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center">*/}
                    {/*            <Camera className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />*/}
                    {/*        </div>*/}
                    {/*    </button>*/}

                    {/*    /!*<div className="mt-2 mr-5">*!/*/}
                    {/*    /!*    <p className="text-sm font-medium text-[#1D3469]">Welcome Back!</p>*!/*/}
                    {/*    /!*    /!*<p className="text-xs text-[#2173B7]">Manage your dashboard</p>*!/*!/*/}
                    {/*    /!*</div>*!/*/}
                    {/*</div>*/}

                    {/* Main Header Content */}
                    <div className="text-center relative overflow-hidden pt-8">
                        <div className="absolute inset-0"></div>
                        <div className="relative z-10">
                            <div>
                                <h1 className="text-5xl font-bold bg-[#D67C2C] bg-clip-text text-transparent mb-4">
                                    Parent Dashboard
                                </h1>
                                <p className="text-[#1D3469] text-xl font-medium max-w-3xl mx-auto px-4">
                                    Monitor your children's academic progress and activities
                                </p>
                            </div>
                        </div>

                                            {/* Parent Profile Picture - Top Right */}
                    <div className="absolute top-4 right-4 z-20">
                        <button
                            onClick={() => setShowParentProfilePictureModal(true)}
                            className="relative group"
                            title="Update Profile Picture"
                        >
                            <div className="w-14 h-14 rounded-full overflow-hidden border-3 border-[#D67C2C] hover:border-[#e06b35] transition-colors shadow-lg">
                                {parentProfilePicture ? (
                                    <img
                                        src={parentProfilePicture}
                                        alt="Your profile"
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <div className="w-full h-full bg-[#FFF8F4] flex items-center justify-center">
                                        <span className="text-[#D67C2C] font-semibold text-lg">
                                            {getParentInitials()}
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Hover overlay */}
                            <div className="absolute inset-0 rounded-full bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center">
                                <Camera className="w-5 h-5 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
                            </div>
                        </button>

                        {/*/!* Welcome text *!/*/}
                        {/*<div className="mt-2 mr-5">*/}
                        {/*    <p className="text-sm font-medium text-[#1D3469]">Welcome Back!</p>*/}
                        {/*    /!*<p className="text-xs text-[#2173B7]">Manage your dashboard</p>*!/*/}
                        {/*</div>*/}
                    </div>
                    </div>
                </div>

                {/* Search and Actions */}
                <div className="max-w-4xl mx-auto mb-12 flex flex-col sm:flex-row items-center justify-center gap-6 px-4">
                    <div className="relative flex-1 min-w-[280px] max-w-xl">
                        <div className="relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                <Search size={18} className="text-gray-400"/>
                            </div>
                            <input
                                type="text"
                                className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D67C2C] focus:border-[#D67C2C]"
                                placeholder="Search children by name or school..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>

                    {/*<div>*/}
                    {/*    <button*/}
                    {/*        className="inline-flex items-center px-4 py-2.5 border border-transparent shadow-sm text-sm font-medium rounded-lg text-white bg-[#D67C2C] hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D67C2C]"*/}
                    {/*        onClick={() => setIsLinkModalOpen(true)}*/}
                    {/*    >*/}
                    {/*        <LinkIcon size={18} className="mr-2"/>*/}
                    {/*        Link New Child*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>

                {/* Error message */}
                {error && (
                    <div className="mb-6 bg-red-50 border-l-4 border-red-500 p-4 rounded-md">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <AlertCircle className="h-5 w-5 text-red-500"/>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm text-red-700">{error}</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Loading state */}
                {loading && (
                    <div className="flex justify-center items-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#D67C2C]"></div>
                    </div>
                )}

                {/* Children List */}
                {!loading && (
                    <div>
                        <h2 className="text-xl font-semibold text-[#D67C2C] mb-4">My Children</h2>

                        {filteredChildren.length === 0 ? (
                            <div className="bg-white rounded-lg shadow p-8 text-center">
                                <Users className="h-12 w-12 text-gray-400 mx-auto mb-4"/>
                                <h3 className="text-lg font-medium text-gray-900 mb-2">
                                    {children.length === 0
                                        ? "No children linked"
                                        : "No matches found"}
                                </h3>
                                <p className="text-gray-500 mb-6">
                                    {children.length === 0
                                        ? "You haven't linked any children to your account yet. Click the \"Link New Child\" button to get started."
                                        : "Try searching with a different name or school."}
                                </p>
                                {/*<button*/}
                                {/*    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[#2173B7] hover:bg-[#e06b35]"*/}
                                {/*    onClick={() => setIsLinkModalOpen(true)}*/}
                                {/*>*/}
                                {/*    <LinkIcon size={16} className="mr-2"/>*/}
                                {/*    Link a Child*/}
                                {/*</button>*/}
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {filteredChildren.map((child) => (
                                    <div
                                        key={child.student_id}
                                        className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow cursor-pointer border-2 border-[#F7D1B6]"
                                        onClick={() => handleChildSelect(child)}
                                    >
                                        <div className="px-6 py-5">
                                            <div className="flex items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="h-16 w-16 rounded-full bg-[#FFF8F4] flex items-center justify-center text-xl font-semibold text-[#2173B7]">
                                                        {child.profile_picture_url ? (
                                                            <img
                                                                src={API_BASE_URL + child.profile_picture_url}
                                                                alt={child.name}
                                                                className="h-12 w-12 rounded-full object-cover border-2 border-[#F7D1B6]"
                                                            />
                                                        ) : (
                                                            <div className="h-12 w-12 rounded-full bg-[#FFF8F4] flex items-center justify-center text-xl text-[#2173B7] font-medium border-2 border-[#F7D1B6]">
                                                                {getInitials(child.name)}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="ml-5 flex-1">
                                                    <h3 className="text-lg font-medium text-[#D67C2C]">{child.name}</h3>
                                                    <div className="mt-1 flex items-center text-sm text-gray-500">
                                                        <Mail className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400"/>
                                                        <p>{child.email}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mt-4 border-t border-gray-200 pt-4 space-y-2">
                                                {child.school && (
                                                    <div className="flex items-center text-sm text-gray-500">
                                                        <School className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400"/>
                                                        <p>{child.school}</p>
                                                    </div>
                                                )}
                                                {child.grade && (
                                                    <div className="flex items-center text-sm text-gray-500">
                                                        <Book className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400"/>
                                                        <p>Grade: {child.grade}</p>
                                                    </div>
                                                )}
                                                {child.country && (
                                                    <div className="flex items-center text-sm text-gray-500">
                                                        <PieChart className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400"/>
                                                        <p>
                                                            {child.state && `${child.state}, `}
                                                            {child.country}
                                                        </p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="px-6 py-3 bg-[#FFF8F4] flex justify-between items-center">
                                            <span className="text-sm font-medium text-[#2173B7]">View detailed information</span>
                                            <span className="text-[#2173B7]">→</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                <LinkChildModal
                    isOpen={isLinkModalOpen}
                    onClose={() => setIsLinkModalOpen(false)}
                    linkEmail={linkEmail}
                    setLinkEmail={setLinkEmail}
                    handleLinkChild={handleLinkChild}
                    loading={loading}
                />
            </div>

            {/* Parent Profile Picture Modal */}
            {showParentProfilePictureModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 shadow-2xl">
                        <h3 className="text-lg font-semibold text-[#1D3469] mb-4">Update Profile Picture</h3>

                        <div className="text-center mb-6">
                            <div className="w-24 h-24 mx-auto mb-4">
                                {parentProfilePicture ? (
                                    <img
                                        src={parentProfilePicture}
                                        alt="Current profile"
                                        className="w-full h-full rounded-full object-cover border-4 border-[#F7D1B6]"
                                    />
                                ) : (
                                    <div className="w-full h-full rounded-full bg-[#FFF8F4] flex items-center justify-center border-4 border-[#F7D1B6]">
                                        <span className="text-2xl font-semibold text-[#D67C2C]">
                                            {getParentInitials()}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <p className="text-sm text-gray-600">
                                Choose a new profile picture (Max 5MB, JPEG/PNG/GIF)
                            </p>
                        </div>

                        <div className="space-y-4">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleParentProfilePictureUpload(e.target.files[0])}
                                disabled={uploadingParentPicture}
                                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-[#FFF8F4] file:text-[#D67C2C] hover:file:bg-[#F7D1B6] file:cursor-pointer cursor-pointer disabled:opacity-50"
                            />

                            <div className="flex space-x-3">
                                <button
                                    onClick={() => setShowParentProfilePictureModal(false)}
                                    disabled={uploadingParentPicture}
                                    className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors disabled:opacity-50"
                                >
                                    Cancel
                                </button>

                                {uploadingParentPicture && (
                                    <div className="flex-1 flex items-center justify-center">
                                        <div className="animate-spin rounded-full h-5 w-5 border-2 border-[#D67C2C] border-t-transparent"></div>
                                        <span className="ml-2 text-sm text-gray-600">Uploading...</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardView;